/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */

/**
 *
 */
// TODO: @JC refactor
export class ResourceIdentifier {

    type: string;
    id?: string;

    constructor(type: string, id?: string) {
        this.type = type;
        if (id) {
            this.id = id;
        }
    }

    setId(id: string): ResourceIdentifier {
        this.id = id;
        return this;
    }

    // TODO @JC: key
}



// WEBPACK FOOTER //
// ./src/utils/json-api/ResourceIdentifier.ts